// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerBody":"Footer_footerBody__2oTUR","footerLine":"Footer_footerLine__L33wF","footerLogo":"Footer_footerLogo__2SOwq"};